var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.863,
    height: 12.863,
    viewBox: "0 0 12.863 12.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44512",
    "data-name": "Group 44512",
    transform: "translate(0.765 0.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89078",
    "data-name": "Path 89078",
    d: "M6.792,10.947,8.3,13.05a1.247,1.247,0,0,0,1.97-.656l3-9.014a1.008,1.008,0,0,0-1.315-1.315l-9.014,3a1.247,1.247,0,0,0-.656,1.97l3.5,2.506",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    x1: 2.888,
    y2: 2.859,
    transform: "translate(3.806 4.637)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.18ae4a8a5d2298f0b5606aa72cfc079b.svg";
export { ForwardRef as ReactComponent };